module.exports = __webpack_public_path__ + "public/SiteIcons/gobalIconTwo.svg?ece319d1";